import React from "react";
import { LimitedList } from "../../../limitedList/limitedList";
import { ITagGroup } from "../../../../models/tagGroups/TagGroupStore";
import { ITag } from "../../../../models/tags/TagsStore";
import { ChipTag } from "../../../chip/presets/ChipTag/ChipTag";
import { ChipTagGroup } from "../../../chip/presets/ChipTagGroup/ChipTagGroup";
import styles from "./tagsList.css";

const ROW_HEIGHT = 20;
const CONTAINER_MAX_HEIGHT = 58; // in line with max-height in `tagsList.css`

interface Props {
  tags?: ITag[];
  tagGroups?: ITagGroup[];
  onTagDelete?(tagId: string): void;
  onTagGroupDelete?(tagGroupId: string): void;
}

export const TagsList = ({ tags, tagGroups, onTagDelete, onTagGroupDelete }: Props) => {
  const renderTags = (elements: ITag[]) => {
    return elements.map((tag) => (
      <ChipTag
        key={tag.id}
        name={tag.name}
        enabled={tag.enabled}
        onDelete={onTagDelete ? () => onTagDelete(tag.id) : undefined}
      />
    ));
  };

  const renderTagGroups = (elements: ITagGroup[]) => {
    return elements.map((tg) => (
      <ChipTagGroup
        key={tg.id}
        enabled={tg.enabled}
        name={tg.name}
        onDelete={onTagGroupDelete ? () => onTagGroupDelete(tg.id) : undefined}
      />
    ));
  };

  return (
    <LimitedList
      maxHeight={CONTAINER_MAX_HEIGHT}
      rowHeight={ROW_HEIGHT}
      className={styles.container}
    >
      {tags && !!tags.length && renderTags(tags)}
      {tagGroups && !!tagGroups.length && renderTagGroups(tagGroups)}
    </LimitedList>
  );
};
